import { render, staticRenderFns } from "./StatementSection.vue?vue&type=template&id=4c789c96&"
import script from "./StatementSection.vue?vue&type=script&lang=js&"
export * from "./StatementSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports